/**
 * @generated SignedSource<<ff13e98fbb419ea356adc53734e2cb24>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priority_nativeIssueTable_PriorityCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "priority_nativeIssueTable_PriorityCell";
};
export type priority_nativeIssueTable_PriorityCell$key = {
  readonly " $data"?: priority_nativeIssueTable_PriorityCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"priority_nativeIssueTable_PriorityCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "priority_nativeIssueTable_PriorityCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "6802a1e026f22ca790d9f99b07f6e464";

export default node;
